import * as d3 from "d3";
import { splitTextByWidth } from "@/components/VivoPlots/functions/addLabels";

const fontSize = "16px";
const fontFamily = "Work Sans";
const fillColor = "#556C75";
const fontSpace = 18;
interface Dimensions {
  width: number;
  height: number;
  marginLeft: number;
  marginRight: number;
  marginBottom: number;
  marginTop: number;
}

const plotPosition = (dimensions: Dimensions) =>
  (2 / 3) * (dimensions.marginTop + dimensions.height);

export const drawNoDataMessage = (
  plotClassName: string,
  dimensions: Dimensions,
  text?: string,
) => {
  const message = text || "No data available for your current selections.";
  const splitText = splitTextByWidth(
    message,
    dimensions.width + dimensions.marginLeft + dimensions.marginRight,
  );

  const svg = d3.select(`svg.${plotClassName}`);

  // Add the SVG icon
  svg
    .append("g")
    .attr("class", "no-data-icon")
    .append("path")
    .attr(
      "d",
      "M1.50773 0.323242L21.177 19.9925L20.1077 21.0617L17.5462 18.5002H4.80773C4.30256 18.5002 3.87498 18.3252 3.52498 17.9752C3.17498 17.6252 2.99998 17.1977 2.99998 16.6925V3.95399L0.438477 1.39249L1.50773 0.323242ZM8.61548 10.4695L4.49998 14.584V16.6925C4.49998 16.7695 4.53206 16.84 4.59623 16.904C4.66023 16.9682 4.73073 17.0002 4.80773 17.0002H16.0462L13.0807 14.0347L12.6557 14.5002L8.61548 10.4695ZM4.49998 5.45399V12.4465L7.99623 8.95024L4.49998 5.45399ZM5.53473 1.50024H18.1922C18.6974 1.50024 19.125 1.67524 19.475 2.02524C19.825 2.37524 20 2.80283 20 3.30799V15.9655L18.5 14.4657V7.92324L15.4135 11.379L14.3442 10.31L18.5 5.67324V3.30799C18.5 3.23099 18.4679 3.16049 18.4037 3.09649C18.3397 3.03233 18.2692 3.00024 18.1922 3.00024H7.03448L5.53473 1.50024Z",
    )
    .attr("fill", "black")
    .attr("fill-opacity", "0.45")
    .attr(
      "transform",
      `translate(${
        (dimensions.marginRight + dimensions.width + dimensions.marginLeft) /
          2 -
        11
      }, ${plotPosition(dimensions) - 30})`,
    );

  // Add the text below the icon
  svg
    .append("text")
    .attr("class", "no-data-message")
    .selectAll("tspan")
    .data(splitText)
    .join("tspan")
    .attr(
      "x",
      (dimensions.marginRight + dimensions.width + dimensions.marginLeft) / 2,
    )
    .attr("y", (d, i) => plotPosition(dimensions) + fontSpace * i + 10)
    .attr("text-anchor", "middle")
    .text((d) => d)
    .attr("font-size", fontSize)
    .attr("font-family", fontFamily)
    .attr("fill", fillColor);

  svg.selectAll(".left-axis-name").remove();
  svg.selectAll(".bottom-axis-name").remove();
};
